import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Star, Quote } from 'lucide-react';
import { mockTestimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-red-50 via-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <Badge className="mb-6 bg-red-100 text-red-800 border-red-200 px-4 py-2">
            Testimonios
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Lo Que Dicen
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-700"> Nuestros Clientes</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            La satisfacción de nuestros clientes es nuestra mayor recompensa. Descubre por qué confían en nosotros para sus proyectos más importantes.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockTestimonials.map((testimonial, index) => (
            <Card 
              key={testimonial.id} 
              className="border-0 shadow-xl bg-white hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group"
            >
              <CardContent className="p-8">
                {/* Quote Icon */}
                <div className="mb-6">
                  <Quote size={40} className="text-red-600/20 group-hover:text-red-600/40 transition-colors duration-300" />
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      size={18}
                      className="text-amber-400 fill-current"
                    />
                  ))}
                </div>

                {/* Content */}
                <p className="text-slate-700 leading-relaxed mb-6 italic">
                  "{testimonial.content}"
                </p>

                {/* Project Info */}
                <div className="bg-red-50 rounded-lg p-4 mb-6">
                  <p className="text-sm font-medium text-red-800">
                    Proyecto: {testimonial.project}
                  </p>
                </div>

                {/* Author */}
                <div className="flex items-center gap-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-14 h-14 rounded-full object-cover border-2 border-red-200"
                  />
                  <div>
                    <h4 className="font-semibold text-slate-900 group-hover:text-red-600 transition-colors duration-300">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-slate-600">{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          {[
            { number: '500+', label: 'Clientes Satisfechos', icon: '😊' },
            { number: '98%', label: 'Tasa de Satisfacción', icon: '⭐' },
            { number: '4.9/5', label: 'Calificación Promedio', icon: '🏆' },
            { number: '24h', label: 'Tiempo de Respuesta', icon: '⚡' }
          ].map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="text-3xl mb-2">{stat.icon}</div>
              <div className="text-2xl md:text-3xl font-bold text-red-600 mb-2 group-hover:scale-110 transition-transform duration-300">
                {stat.number}
              </div>
              <div className="text-sm md:text-base text-slate-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-lg text-slate-600 mb-6">
            ¿Listo para ser nuestro próximo cliente satisfecho?
          </p>
          <Badge className="bg-red-600 text-white px-6 py-3 text-base hover:bg-red-700 cursor-pointer transition-colors duration-300">
            Únete a Nuestros Clientes Felices
          </Badge>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;